import axios from 'axios'

import router from '../router'
import store from '../store'

// axios 配置
axios.defaults.timeout = 30000
axios.defaults.baseURL = '/api/v1'

// 请求拦截器
axios.interceptors.request.use(config => {
  if (store.state.user.token) { //  请求之前判断token是否存在
    config.headers.Authorization = `Bearer ${store.state.user.token}`
  }
  // 权限校验

  // 带上clientId 和 roleIds
  if (window.localStorage.clientId) {
    config.headers.clientId = window.localStorage.clientId
  }
  if (window.localStorage.roleIds) {
    config.headers.roleIds = window.localStorage.roleIds
  }

  return config
}, err => {
  return Promise.reject(err)
})

// 添加响应拦截器
axios.interceptors.response.use(response => {
  return response.data
}, err => {
  if (err.response) {
    switch (err.response.status) {
      case 401:
        store.commit('LOGOUT')
        router.replace({
          path: '/',
          query: {
            redirect: router.currentRoute.fullPath
          }
        })
        break
      case 403:
        store.commit('LOGOUT')
        router.replace({
          path: '/',
          query: {
            redirect: router.currentRoute.fullPath
          }
        })
        break
    }
  }
  return Promise.reject(new Error(err.response.data.error || err.message))
})

/**
 * @param  {string} url
 * @param  {object} params={}
 */
const fetch = (url, params = {}) => axios.get(url, {
  params
})
/**
 * @param  {string} url
 * @param  {object} data={}
 */
const post = axios.post

/**
 * @param  {string} url
 * @param  {object} data={}
 */
const put = axios.put

/**
 * @param  {string} url
 * @param  {object} params={}
 */
const del = (url, params = {}) => axios.delete(url, {
  params
})

export {
  axios,
  fetch,
  post,
  put,
  del
}



// WEBPACK FOOTER //
// ./src/http/base.js